// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1W-iH","select":"Header_select__Ia5-E","clinic":"Header_clinic__1pXSR"};